import classNames from "classnames";
import BootDatePicker from "components/common/custom/forms/BootDatePicker";
import TextInput from "components/common/custom/forms/BootTextField/TextField";
import MultiSelect from "components/common/MultiSelect";
import { GetAllPoyer } from "features/eliglibility/eligibility-check-list/config/eligibilityCheckListApi";
import { GetInsuranceList } from "features/eliglibility/eliglibility-check/config/eligibilityCheckApi";
import { GetAllClaimPreAuthAllList } from "features/preauthorization/config/preauthorizationApi";
import moment from "moment";
import React, { useEffect } from "react";
import { Col, Form, Row } from "react-bootstrap";
import { Controller } from "react-hook-form";
import { useDispatch, useSelector } from "react-redux";
import { useParams } from "react-router-dom";

const AddPriceForm = ({
  control,
  watch,
  setValue,
  errors,
  isSubmitted,
  view,
}) => {
  const dispatch = useDispatch();
  const { individualData } = useSelector((state) => state.price);
  const { poyerList } = useSelector((state) => state.eligibilityCheckList);
  const { serviceTypeList } = useSelector((state) => state.preauthorization);
  const { id } = useParams();
  const allBranches = JSON.parse(localStorage.getItem("branch_settings")) || [];
  useEffect(() => {
    if (poyerList?.length === 0) {
      dispatch(GetAllPoyer());
    }
    if (serviceTypeList?.length === 0) {
      dispatch(GetAllClaimPreAuthAllList());
    }
  }, [poyerList, serviceTypeList]);

  useEffect(() => {
    if (id) {
      setValue(
        "branch",
        allBranches?.find(
          (item) => item?.branch_cchino === individualData?.brcchi
        )
      );
      setValue(
        "payer",
        poyerList?.find(
          (item) => item?.payer_name === individualData?.payer_name
        )
      );
      setValue("nphies_code", individualData?.nphies_code);
      setValue("provider_code", individualData?.provider_code);
      setValue("provider_description", individualData?.provider_codedesc);
      setValue("price", individualData?.unit_price);
      setValue("discount", individualData?.price_discount);
      setValue("vat", individualData?.price_tax);
      setValue(
        "activiation_date",
        individualData?.activated_date
          ? moment(individualData).format("YYYY-MM-DD")
          : ""
      );
    }
  }, [id, individualData]);

  return (
    <Row>
      {!id ? (
        <Col xs={12} sm={6} md={3} xl={2}>
          <label className="form-label">
            Branches <span className="text-danger">*</span>
          </label>
          <Controller
            name="branch"
            control={control}
            rules={{
              required: "At least one branch is required",
              validate: (v) =>
                v?.length > 0 || "Please select at least one branch",
            }}
            render={({ field }) => (
              <MultiSelect
                {...field}
                isMulti
                disabled={view}
                options={allBranches.map((b) => ({
                  value: b.branch_id,
                  label: b.branch_name,
                  cchi: b.branch_cchino,
                }))}
                value={watch("branch")}
                onChange={(val) => setValue("branch", val)}
                className={classNames({
                  "is-invalid": errors.branch,
                })}
                placeholder="Choose multi"
              />
            )}
          />
        </Col>
      ) : (
        <Col xs={12} sm={6} md={3} xl={2}>
          <label className="form-label">
            Branch <span className="text-danger">*</span>
          </label>
          <Controller
            name="branch"
            control={control}
            rules={{
              required: true,
            }}
            render={({ field }) => (
              <MultiSelect
                {...field}
                isMulti={false}
                isClearable={true}
                options={allBranches.map((b) => ({
                  value: b.branch_id,
                  label: b.branch_name,
                  cchi: b.branch_cchino,
                }))}
                value={
                  field?.value
                    ? {
                        value: field?.value?.branch_id,
                        label: field?.value?.branch_name,
                        cchi: field?.value?.branch_cchino,
                      }
                    : null
                }
                onChange={(selected) => {
                  setValue(
                    "branch",
                    selected
                      ? {
                          branch_id: selected?.value,
                          branch_name: selected?.label,
                          branch_cchino: selected?.cchi,
                        }
                      : null
                  );
                }}
                className={classNames({
                  "is-invalid": errors.branch,
                })}
                placeholder="Choose branches..."
              />
            )}
          />
        </Col>
      )}
      <Col xs={12} sm={6} md={3} xl={2}>
        <label className="form-label">Payer</label>
        <Controller
          name="payer"
          control={control}
          rules={{ required: false }}
          render={({ field }) => (
            <MultiSelect
              {...field}
              menuPlacement="auto"
              closeMenuOnSelect={false}
              isMulti={false}
              options={poyerList?.map((item) => ({
                value: item.payer_id,
                label: item.payer_name,
                cchi: item?.payer_cchi,
              }))}
              isClearable={true}
              value={
                field?.value
                  ? {
                      value: field.value.payer_id,
                      label: field.value.payer_name,
                      cchi: field.value.branch_cchino,
                    }
                  : null
              }
              onChange={(selected) => {
                setValue(
                  "payer",
                  selected
                    ? {
                        payer_id: selected?.value,
                        payer_name: selected?.label,
                        branch_cchino: selected?.cchi,
                      }
                    : null
                );
              }}
              formatOptionLabel={({ label }) => <div>{label}</div>}
              getOptionValue={(option) => option.value}
              placeholder="Choose ..."
            />
          )}
        />
      </Col>
      {/* <Col xs={12} sm={6} md={3} xl={2}>
        <label className="form-label">
          Service Type <span className="text-danger">*</span>
        </label>
        <Controller
          name="service_type"
          control={control}
          rules={{ required: true }}
          render={({ field }) => (
            <MultiSelect
              {...field}
              menuPlacement="auto"
              closeMenuOnSelect={false}
              isMulti={false}
              options={serviceTypeList.map((item) => ({
                value: item.servtype_code,
                label: item.servtype_name,
              }))}
              className={classNames({
                "is-invalid": errors.service_type,
              })}
              value={
                field.value
                  ? {
                      value: field.value.servtype_code,
                      label: field.value.servtype_name,
                    }
                  : null
              }
              onChange={(selected) => {
                setValue(
                  "service_type",
                  selected
                    ? {
                        servtype_code: selected.value,
                        servtype_name: selected.label,
                      }
                    : null
                );
              }}
              formatOptionLabel={({ label }) => <div>{label}</div>}
              getOptionValue={(option) => option.value}
              placeholder="Choose ..."
            />
          )}
        />
      </Col> */}
      <Col xs={12} sm={6} md={3} xl={2}>
        <TextInput
          name="nphies_code"
          label="Nphies Code "
          placeholder="Nphies Code "
          control={control}
          size="sm"
          errors={errors}
          required={true}
        />
      </Col>
      <Col xs={12} sm={6} md={3} xl={2}>
        <TextInput
          name="provider_code"
          label="Provider Code"
          placeholder="Provider Code"
          control={control}
          size="sm"
          errors={errors}
          required={false}
        />
      </Col>
      <Col xs={12} sm={6} md={3} xl={2}>
        <TextInput
          name="provider_description"
          label="Provider Description "
          placeholder="Provider Description "
          control={control}
          size="sm"
          errors={errors}
          required={false}
        />
      </Col>
      <Col xs={12} sm={6} md={3} xl={2}>
        <TextInput
          name="price"
          label="Price"
          placeholder="Price"
          type="number"
          min={0}
          control={control}
          size="sm"
          errors={errors}
          required={true}
        />
      </Col>
      <Col xs={12} sm={6} md={3} xl={2}>
        <TextInput
          name="discount"
          label="Discount %"
          placeholder="Discount"
          type="number"
          min={0}
          max={100}
          control={control}
          size="sm"
          errors={errors}
          required={true}
        />
      </Col>
      <Col xs={12} sm={6} md={3} xl={2}>
        <Controller
          name="vat"
          control={control}
          errors={errors}
          rules={{ required: true }}
          render={({ field }) => (
            <Form.Group>
              <Form.Label className="form-label">
                VAT <span className="text-danger">*</span>
              </Form.Label>
              <Form.Select
                {...field}
                size="sm"
                value={field.value ?? ""} // ensure empty string is used when value is undefined
                onChange={(e) => {
                  const value = e.target.value;
                  field.onChange(value === "" ? null : Number(value));
                }}
              >
                <option value="">Select VAT</option>
                <option value="0">Vat - 0 %</option>
                <option value="15">Vat - 15 %</option>
              </Form.Select>
            </Form.Group>
          )}
        />
      </Col>
      <Col xs={12} sm={6} md={3} xl={2}>
        <BootDatePicker
          name="activiation_date"
          label="Activation Date"
          size="sm"
          control={control}
          errors={errors}
          selected={watch("activiation_date")}
          onChange={(date) => setValue("activiation_date", date)}
          placeholder="dd/mm/yyyy"
        />
      </Col>
    </Row>
  );
};

export default AddPriceForm;
